<template>
  <div class="vertical-card" v-if="asset">
    <router-link :to="url">
      <icon-position
        v-if="type === 'top'"
        class="pill"
        :number="position + 1"
      />
      <img
        :src="asset.poster?.mid ?? asset.poster"
        :alt="asset.title"
        :title="asset.title"
      />
    </router-link>
  </div>
</template>

<script>
import IconPosition from "@/components/icons/iconPosition.vue";

export default {
  name: "VerticalCard",
  components: { IconPosition },
  props: {
    asset: Object,
    default: function () {
      return null;
    },
    position: Number,
    type: String,
  },
  computed: {
    url() {
      let url = this.$t("movie_route", { slug: this.asset.slug });
      if (this.asset.type === "series") {
        url = this.$t("serie_route", { slug: this.asset.slug });
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.vertical-card {
  margin: 0 0 0 1em;
  .pill {
    margin: auto;
    position: relative;
    bottom: -2.2em;
  }

  img {
    border-radius: 16px;
    border: 2px solid #ffffff00;
    transition: all 0.3s ease-in-out;
    transform: scale(0.95);
  }

  &:hover {
    img {
      transform: scale(1);
      border: 2px solid #ffffffff;
      transition: all 0.3s ease-in-out;
    }
  }
}
</style>
